import {useFormContext} from 'react-hook-form';
import Input from '@/components/common/Input';
import {
  ReactComponent as RiDeleteBinLine
} from '@/assets/icons/ri-delete-bin-line.svg';
import FileInput from '@/components/common/FileInput';
import NewMap from "@/components/common/NewMap";
import {useAppDispatch} from '@/store';
import {uploadFiles} from '@/store/file/action';
import {acceptedFileTypes, MAX_FILE_SIZE} from "@/config/app";

const Information = () => {
  const {register, getValues, setValue, watch} = useFormContext();
  const court_pictures = watch('court_pictures');
  const long = watch('address_long')
  const lat = watch('address_lat')
  
  const dispatch = useAppDispatch();
  
  const setFileFromResponse = (response) => {
    const { payload } = response
    setValue('court_pictures', [payload.url])
  }
  
  const handleChangeFile = (fileInput?: File) => {
    if (fileInput && fileInput.size < MAX_FILE_SIZE) {
      const formData = new FormData();
      formData.append('file', fileInput);
      dispatch(uploadFiles({ formData })).then(setFileFromResponse)
    }
  };
  
  const handleSetAddress = (addressObj: UpdateAddressObject) => {
    setValue('address', addressObj.address)
    setValue('address_lat', addressObj.lat)
    setValue('address_long', addressObj.long)
  }
  
  const deleteFile = () => {
    setValue('court_pictures', []);
  };
  
  return (
    <div className="card-base col-span-2">
      <div className="text-jlg mb-7">Venue Information</div>
      <div className="grid grid-cols-3 gap-7">
        <div className="flex flex-col w-full gap-2">
          <div className="text-jsm">Venue Name</div>
          <div>
            <Input
              name="name"
              type="text"
              placeholder="Fill Venue Name"
              expanded
            />
          </div>
          <div className="text-jsm mt-2">Whatsapp Number</div>
          <div>
            <Input
              name="pic_phone_number"
              type="number"
              placeholder="e.g 6281234567890"
              expanded
            />
          </div>
          <div className="text-jsm mt-2">Full Address</div>
          <textarea
            {...register('address')}
            className="j-text-area w-full"
            placeholder="Enter full address"
          />
          <div className="text-jsm mt-2">App Payment Methods</div>
          <div className="flex flex-row w-full justify-start items-center gap-2">
            <input className="mr-2" type="checkbox" id="app_payments_online" value="ONLINE" name="app_payments[]" 
              {...register('app_payments')}
            />
            <label className="text-jsm text-grey font-normal" htmlFor="app_payments_online">Online</label>
          </div>
          <div className="flex flex-row w-full justify-start items-center gap-2">
            <input className="mr-2"  type="checkbox"  id="app_payments_onthespot" value="ON_THE_SPOT" name="app_payments[]" 
              {...register('app_payments')}
            />
            <label className="text-jsm text-grey font-normal" htmlFor="app_payments_onthespot">On The Spot </label>
          </div>
          <div className="text-jsm mt-2">Local Tax Fee (%)</div>
          <div>
            <Input
              name="tax_fee"
              type="number"
              placeholder="e.g. 10%"
              defaultValue="0"
              expanded
            />
          </div>
        </div>
        <div className="flex flex-col w-full h-full gap-2">
          <div className="text-jsm">Location Pin</div>
          <NewMap
            onUpdateAddress={handleSetAddress}
            lat={lat}
            lng={long}
          />
          {lat}, {long}
        </div>
        <div className="flex flex-col w-full h-full gap-2">
          <div className="text-jsm">Upload Court Map</div>
          <FileInput setFile={handleChangeFile}
                     accept={acceptedFileTypes}/>
          {court_pictures.length ? (
            <div className="flex gap-2 mt-2">
              <div className="rounded overflow-hidden">
                <img
                  src={getValues('court_pictures.0')}
                  alt=""
                  className="h-[50px] w-[100px] object-cover"
                />
              </div>
              <div className="flex flex-grow justify-between items-center">
                <button
                  onClick={() => deleteFile()}
                  type="button"
                  className="text-red-primary"
                >
                  <RiDeleteBinLine/>
                </button>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};

export default Information;
